module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-analytic-5.9744155b.svg";